<template>
  <ul class="article-links">
    <li class="article-link-item hidden-sm-down" v-if="!$store.state.isEnhanced && article.abstract"><a @click="toggleAbstract()">Abstract</a></li>
    <li class="article-link-item" v-if="article && article.files.pdf && article.files.pdf.display"><a :href="article.files.pdf.url">PDF</a></li>
    <li class="article-link-item" v-if="!$store.state.isEnhanced"><a @click="setEnhancedView(false, {name: 'article-detail', params: {pii: article.ids.pii}})">Full text</a></li>
    <li class="article-link-item" v-if="!$store.state.isEnhanced"><a @click="setEnhancedView(true, {name: 'article-detail', params: {pii: article.ids.pii}})">Enhanced View</a></li>
    <li class="article-link-item" v-if="$store.state.isEnhanced"><a @click="setEnhancedView(false, {name: 'article-detail', params: {pii: article.ids.pii}})">Traditional View</a></li>
    <li class="article-link-item"><a>How to Cite</a></li>
    <li class="article-link-item hidden-sm-down">
      <a @click="$root.$emit('show::modal','orderReprintModal', article)">Order a Reprint</a>
    </li>
    <li class="article-link-item hidden-sm-down"><a>Related Articles</a></li>
  </ul>
</template>

<script>
  export default {
    name: 'article-quick-links',
    props: ['article'],
    methods: {
      setEnhancedView (isEnhanced, routeParams) {
        this.$store.commit('setMode', isEnhanced)
        if (routeParams) {
          this.$router.push(routeParams)
        }
      },
      toggleAbstract () {
        if (this.$parent.toggleAbstract) {
          this.$parent.toggleAbstract()
        }
      }
    }
  }
</script>


<style lang="scss" scoped>
  .article-links {
    list-style: none;
    padding: 0;
    margin: 15px 0 0;
    height: 16px;
    .article-link-item {
      display: flex;
      float: left;
      font-family: 'Merriweather', serif;
      font-size: 14px;
      font-weight: 300;
      font-style: italic;
      line-height: 1.31;
      text-align: left;
      &:not(:last-child):after  {
        content: "|";
        color: #cccccc;
        padding: 0 8px;
      }
      a {
        white-space: nowrap;
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// ArticleQuickLinksComponent.vue?4e9cbc35